var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#0A4DCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2739 23.7164H37.5025V20.5184H39.1045V23.7164H42.3331V25.4543H39.1045V28.6522H37.5025V25.4543H34.2739V23.7164Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2739 23.7164H37.5025V20.5184H39.1045V23.7164H42.3331V25.4543H39.1045V28.6522H37.5025V25.4543H34.2739V23.7164Z",
    stroke: "white",
    strokeWidth: 0.477229,
    strokeMiterlimit: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3237 32.95H16.1403C16.4311 32.95 16.4674 32.6474 16.5401 32.418C16.5764 32.3106 16.6128 32.1935 16.6491 32.0715C16.7037 31.9544 16.7219 31.847 16.7764 31.6957L19.0842 25.0095C19.1387 24.8826 19.1569 24.7704 19.2114 24.6337C19.2841 24.419 19.3568 24.1994 19.4476 23.9504C19.5021 23.8187 19.5203 23.7406 19.5567 23.6039C19.6839 23.2574 20.1563 22.0227 20.1745 21.7884L22.7368 29.2653C22.7731 29.4214 22.8095 29.6508 23.0275 29.6508C23.3546 29.6508 23.4091 29.2359 23.5182 28.9871L23.8635 28.172C23.9907 27.8402 24.8811 25.8441 24.8811 25.7367C24.8811 25.6635 24.663 24.99 24.6085 24.8631L21.919 16.6005C21.8645 16.4736 21.701 16.4199 21.5192 16.4199H19.0479C18.7934 16.4199 18.6844 16.4883 18.6117 16.6835C18.5572 16.8445 18.5027 17.0544 18.43 17.2252C18.2301 17.723 17.9212 18.7723 17.7031 19.3433C17.3397 20.295 16.9581 21.5639 16.6128 22.5205L16.2494 23.5746C16.1767 23.765 16.1222 23.9309 16.0495 24.1164C15.9768 24.3067 15.9404 24.4727 15.8677 24.663L13.251 32.0325C13.1783 32.213 13.1056 32.3887 13.0511 32.5693C12.9784 32.7792 13.0692 32.95 13.3237 32.95Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4629 32.6812C24.4629 32.8618 24.5538 32.9496 24.7355 32.9496H27.8429C28.0428 32.9496 28.2245 32.32 28.3336 32.0223L28.7333 30.9584C28.7878 30.8071 28.8605 30.6167 28.9151 30.4557C29.3148 29.4747 29.7146 28.3083 30.1144 27.3029L30.3143 26.771C30.387 26.5806 30.4415 26.4245 30.5142 26.239L33.876 17.259C34.2395 16.2243 34.3121 16.4196 31.0412 16.4196C30.6414 16.4196 30.6051 16.7173 30.4234 17.22C30.3688 17.381 30.2961 17.542 30.2234 17.7177L29.6238 19.2648C29.4784 19.6114 29.3693 19.9384 29.224 20.2849C29.1695 20.3727 29.1695 20.4411 29.1331 20.5387L27.2069 25.4337C27.0615 25.7607 26.9525 26.1024 26.8071 26.4538C26.7344 26.6343 26.698 26.771 26.6254 26.9516C26.5709 27.0492 26.5527 27.1175 26.5163 27.2004C26.48 27.3176 26.4437 27.3712 26.4073 27.4689C26.0439 28.4205 25.5532 29.6455 25.2443 30.568C25.1716 30.7729 24.4629 32.525 24.4629 32.6812Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16.2294V16.2538V16.288C6.07266 16.6638 6.7087 18.1425 6.83591 18.4353L9.27098 24.531C9.88882 26.0293 10.5975 27.9034 11.1972 29.3334C11.3789 29.7531 11.3971 30.0752 11.7242 30.0752C11.9423 30.0752 12.1603 29.3968 12.2693 29.1479L13.5959 26.0488C13.5959 25.8585 11.4879 20.8072 11.1972 20.0215L9.77976 16.5076C9.67075 16.244 9.65256 16 9.36183 16H6.27257C6.10901 16 6 16.083 6 16.2294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiseLogo);
export default __webpack_public_path__ + "static/media/WiseLogo.d42108c5403f5ba824b21bd989e458dd.svg";
export { ForwardRef as ReactComponent };